import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SvgLogoGoogleAnalytics(props) {
	if (props["aria-label"]) {
		props = {
			...props,
			role: "img"
		};
	} else {
		props = {
			...props,
			role: "presentation",
			"aria-hidden": "true"
		};
	}
	return /* @__PURE__ */ _jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 90 100",
		...props,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M90 87.5c0 3.6-1.5 7-4.1 9.3-2.6 2.4-6.2 3.5-9.7 3.1-6.3-.9-11-6.5-10.8-12.9V13C65.2 6.6 69.8 1 76.2.1c3.5-.4 7.1.7 9.7 3.1S90 8.9 90 12.5v75z",
			fill: "#f9ab00"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.3 75.2c6.8 0 12.3 5.5 12.3 12.4 0 6.8-5.5 12.4-12.3 12.4S0 94.5 0 87.6c0-6.8 5.5-12.4 12.3-12.4zm32.5-37.5c-6.8.4-12.2 6.1-12 13V84c0 9 4 14.5 9.8 15.7 3.6.7 7.4-.2 10.3-2.6 2.9-2.4 4.5-5.9 4.5-9.6V50.1c0-3.3-1.3-6.5-3.7-8.9-2.4-2.3-5.6-3.6-8.9-3.5z",
			fill: "#e37400"
		})]
	});
}
export { SvgLogoGoogleAnalytics as ReactComponent };
